export default {
  hero: {
    badge: "Centre de ressources AllChinaBuy Spreadsheet",
    title: 'AllChinaBuy Spreadsheet – Trouvez des produits, comparez et achetez malin',
    subtitle: "Explorez le AllChinaBuy Spreadsheet dans un espace organisé. Découvrez des trouvailles, des catégories populaires, des guides QC, des infos de livraison, des avis et des ressources pratiques.",
    ctaPrimary: 'Explorer le AllChinaBuy Spreadsheet',
    ctaSecondary: 'Voir les trouvailles populaires',
    mainCta1: 'allchinabuy spreadsheet',
    mainCta2: 'acheter maintenant',
  },
  search: {
    label: 'Rechercher dans le AllChinaBuy Spreadsheet',
    placeholder: 'Rechercher catégories, guides, avis...',
    categoryLabel: 'Parcourir par catégorie',
    selectPlaceholder: 'Choisir une catégorie',
    go: 'Aller à la catégorie',
  },
  categories: {
    title: 'Catégories populaires',
    subtitle: "Accédez directement aux produits qui vous intéressent. Chaque catégorie s'ouvre sur le AllChinaBuy spreadsheet principal.",
  },
  guides: {
    title: 'Guides et ressources',
    subtitle: 'Des guides pratiques couvrant contrôle qualité, livraison, avis et achats sécurisés.',
  },
  featured: {
    title: 'Trouvailles en vedette',
    subtitle: 'Un aperçu des produits que les gens sauvegardent le plus souvent dans leurs tableurs.',
    items: [
      { title: 'Baskets durables au quotidien', body: 'Des silhouettes nettes et de bons matériaux en font un choix récurrent dans de nombreuses listes.' },
      { title: 'Hoodies streetwear amples', body: 'Le coton épais et les coupes oversize dominent la section hoodies du tableur.' },
      { title: 'Tees logo minimalistes', body: 'Des t-shirts simples et polyvalents, parfaits en superposition et abordables.' },
      { title: 'Vestes utilitaires et manteaux', body: 'Des tissus techniques et des coupes décontractées pour toutes les saisons.' },
    ],
  },
  qc: {
    title: 'Guide QC',
    subtitle: "Comment lire les photos de contrôle qualité avant l'expédition.",
    body: "Avant que vos articles ne quittent l'entrepôt, examinez attentivement les photos QC. Vérifiez les coutures, la fidélité des couleurs, le placement du logo et les mesures par rapport au guide des tailles.",
  },
  shipping: {
    title: 'Guide de livraison',
    subtitle: 'Comprenez vos options et coûts de livraison.',
    body: "Comparez les lignes de livraison selon la vitesse, le prix et la fiabilité. Les articles lourds ou volumineux coûtent souvent plus cher, donc regrouper un colis complet fait souvent économiser.",
  },
  review: {
    title: 'Avis AllChinaBuy',
    subtitle: 'Un regard honnête sur son fonctionnement.',
    body: "De la commande au suivi du colis, découvrez à quoi vous attendre, les points forts du service et les pièges à éviter.",
  },
  safety: {
    title: 'Centre de sécurité',
    subtitle: 'Achetez en toute confiance.',
    body: "Conseils pour la sécurité du compte, les paiements sûrs, l'évitement des contrefaçons et la compréhension des douanes et produits restreints.",
  },
  articles: {
    title: 'Derniers articles',
    subtitle: 'Des guides approfondis et des avis honnêtes pour acheter plus malin.',
    readMore: "Lire l'article",
    viewAll: 'Voir tous les articles',
  },
  faq: {
    title: 'Questions fréquentes',
    subtitle: 'Des réponses rapides aux questions les plus courantes.',
    items: [
      { q: "Qu'est-ce que le AllChinaBuy Spreadsheet ?", a: "C'est une collection organisée de trouvailles, de catégories et de ressources qui vous aide à découvrir et comparer des articles avant d'acheter." },
      { q: 'AllChinaBuy est-il légitime ?', a: 'Vérifiez toujours les politiques actuelles vous-même. Nos guides vous aident à comprendre le processus, mais vous devez consulter les conditions, les évaluations des vendeurs et la réglementation locale.' },
      { q: 'Combien coûte la livraison ?', a: 'Le coût dépend du poids, de la taille, de la destination et de la ligne choisie. Regrouper les articles en un seul colis réduit souvent le total.' },
      { q: 'Comment lire les photos QC ?', a: "Vérifiez les coutures, les couleurs, les logos et les mesures par rapport à l'annonce et au guide des tailles. Signalez toute différence avant l'expédition." },
    ],
  },
  cta: {
    title: 'Prêt à explorer tout le spreadsheet ?',
    subtitle: 'Visitez le site principal pour parcourir chaque catégorie et trouver votre prochain coup de cœur.',
    button: 'Visiter le site principal',
  },
};